export const ShopCreditCardRoutes = {
    ROOT: "/shop-credit-card",
    PERSONAL_DATA: "/shop-credit-card/personal-data",
    CARD_INFO: "/shop-credit-card/card-info",
    NEW_PHONE: "/shop-credit-card/new-phone",
    NEW_ADDRESS: "/shop-credit-card/new-address",
    SUMMARY: "/shop-credit-card/summary",
    SIGNING: "/shop-credit-card/signing",
    SUCCESS: "/shop-credit-card/success"
};


// WEBPACK FOOTER //
// ./src/components/shopCreditCard/ShopCreditCardRoutes.ts